import * as PIXI from 'pixi.js';
const ArrowEffect = function() {
	PIXI.Sprite.call(this);
	this.texture = PIXI.utils.TextureCache['arrow_thin.png'];
}
ArrowEffect.prototype = Object.create(PIXI.Sprite.prototype)
ArrowEffect.prototype.constructor = ArrowEffect
export default ArrowEffect
